import type { CarouselsType } from '@/types';
import { useLingui } from '@lingui/react';
import { Avatar, Box, Card, Group, Image, NumberFormatter, Stack, Text } from '@mantine/core';
import { IconUserFilled } from '@tabler/icons-react';
import { AvailableButton } from './AvailableButton';
import { UnavailableButton } from './UnavailableButton';
export type GameBattleCardProps = CarouselsType & {
  bonus: number;
  player: number;
  userAvatar: string;
  username: string;
  status: 'available' | 'unavailable';
  time: string;
  btnStatus: 'started' | 'active' | 'completed' | undefined;
};
export const GameBattleCard: React.FC<GameBattleCardProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Card w="100%" miw={{
    md: 205
  }} radius={5} bg="var(--bg-400)" p={{
    base: 10,
    lg: 20
  }} style={{
    cursor: 'pointer'
  }}>
      <Stack h="100%" gap={10}>
        <Image src={props.imgCard} alt="games" w="100%" radius={5} />

        <Group justify="space-between" wrap="nowrap" mt={6}>
          <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Bonus buy')}
          </Text>
          <Box w={62}>
            <Text truncate="end" fz="xs" c="var(--text-green)" fw={700} ta="right">
              <NumberFormatter value={props.bonus} prefix="$" thousandSeparator="," decimalScale={2} decimalSeparator="." fixedDecimalScale />
            </Text>
          </Box>
        </Group>

        <Group justify="space-between" wrap="nowrap">
          <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Players')}
          </Text>

          <Group gap={4} justify="end">
            <IconUserFilled color="var(--icon-primary)" />

            <Text truncate="end" fz={13} fw={500} c="var(--text-dark)">
              {props.player} / 5
            </Text>
          </Group>
        </Group>

        <Group justify="space-between" wrap="nowrap">
          <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Creator')}
          </Text>

          <Group gap={4} justify="end">
            <Avatar src={props.userAvatar} size={14} />
            <Box w={45}>
              <Text truncate="end" fz={13} fw={500} c="var(--text-dark)">
                {props.username}
              </Text>
            </Box>
          </Group>
        </Group>

        {props.status === 'available' ? <AvailableButton status={props.status} time={props.time} /> : <UnavailableButton status={props.status} btnStatus={props.btnStatus} />}
      </Stack>
    </Card>;
};